import io from "socket.io-client";
import config from "../../config";
import axios from "axios";
const socket = io.connect(process.env.APP_ENV === "local" ? "" : "", {
  closeOnBeforeunload: false
});
const Bootstrap = () => {
  /**
   * Init CSS environment variables
   */

  const root = document.documentElement;
  root.style.setProperty("--edit", "#fcbc4c");
  root.style.setProperty("--outline-orange", "#fbbd08");
  root.style.setProperty("--button-green", "#00b5ad");
  /**
   * We'll load the axios HTTP library which allows us to easily issue requests
   * to our Laravel back-end. This library automatically handles sending the
   * CSRF token as a header based on the value of the "XSRF" token cookie.
   */

  window.axios = axios;

  /**
   * Next we will register the CSRF Token as a common header with Axios so that
   * all outgoing HTTP requests automatically have it attached. This is just
   * a simple convenience so we don't have to attach every token manually.
   */

  let api_token = document.head.querySelector('meta[name="api-token"]');
  if (api_token) {
    document.cookie = "api_token=" + api_token.content;
    window.axios.defaults.headers.common.Authorization =
      "Bearer " + api_token.content;
  } else if (process.env.NODE_ENV !== "test") {
    console.debug(
      "CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token"
    );
  }

  socket.on("connect", () => {
    window.axios.defaults.headers.common.Websocket = socket.id;
    window.axios.defaults.headers.common["tk-ws-tb"] = socket.id;
    if (api_token) {
      window.axios.defaults.headers.common["tk-api-tk"] = api_token.content;
    }
    window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
  });

  //  Prevent console logging on Prod
  window.consoleLog = function() {
    if (process.env.APP_ENV !== "production") {
      console.log(...arguments);
    } else {
      console.log(Math.random());
    }
  };
  window.consoleDebug = function() {
    console.debug(...arguments);
  };

  // Warn if overriding existing method
  if (Array.prototype.equals) {
    console.warn(
      "Overriding existing Array.prototype.equals. Possible causes: New API defines the method, there's a framework conflict or you've got double inclusions in your code."
    );
  }
  // attach the .equals method to Array's prototype to call it on any array
   
  Array.prototype.equals = function(array) {
    // if the other array is a falsy value, return
    if (!array) {
      return false;
    }

    // compare lengths - can save a lot of time
    if (this.length !== array.length) {
      return false;
    }

    for (let i = 0, l = this.length; i < l; i++) {
      // Check if we have nested arrays
      if (this[i] instanceof Array && array[i] instanceof Array) {
        // recurse into the nested arrays
        if (!this[i].equals(array[i])) {
          return false;
        }
      } else if (this[i] !== array[i]) {
        // Warning - two different object instances will never be equal: {x:20} != {x:20}
        return false;
      }
    }
    return true;
  };
  // Hide method from for-in loops
   
  Object.defineProperty(Array.prototype, "equals", { enumerable: false });
};

export { socket };
export default Bootstrap;
